<template>
  <div class="wl-container">
    <el-upload class="uploader"
               ref="upload"
               :data="{siteId:getSite.siteId}"
               :action="actionUrl"
               :headers="headers"
               :accept="actionUrl"
               :show-file-list="false"
               :on-success="handleAvatarSuccess"
               :before-upload="beforeAvatarUpload">
      <el-input readonly
                suffix-icon="el-icon-folder-opened"
                v-model="imageName"></el-input>
    </el-upload>
    <el-input type="textarea"
              class="textarea"
              :rows="6"
              maxlength="1000"
              show-word-limit
              :placeholder="$t('NEW_COMMENT')"
              v-model="content"></el-input>
    <div class="wl-btn-container">
      <el-button class="wl-grey"
                 @click="onCancel">{{$t('comment_reSet')}}
      </el-button>
      <el-button class="wl-green"
                 :loading="loading"
                 @click="onSend(content,pid)">{{$t('comment_send')}}
      </el-button>

    </div>
  </div>
</template>
<script>
  import requestUrl from '@/api/requestUrl'
  import {checkIsValidExtension} from '@/utils/fileType'
  import {mapGetters} from 'vuex'

  export default {
    data() {
      return {
        headers: {},
        actionUrl: requestUrl('/client/clientMatterLog/uploadMatterFile'),
        content: '',
        imageName: '',
        attachmentList: []
      };
    },
    computed: {
      ...mapGetters('common', {
        getSite: 'getSite',
        getUser: 'getUser',
      })
    },
    methods: {
      onSend(content, pid) {
        if (content.length > 0) {
          this.onAdd(content, pid, this.attachmentList)
        } else {
          this.$message.error(this.$t('NEW_COMMENTS_NULL'))
        }
        this.content = ''
        this.imageName = ''
        this.attachmentList = []
      },
      onCancel() {
        this.content = ''
      },
      handleAvatarSuccess(res, file, files) {
        if (res.code == '1') {
          this.imageName = file.name
          this.attachmentList = []
          this.attachmentList.push({
            id: res.data,
            name: file.name,
            uploadBy: this.getUser.profitCenter ? this.getUser.userName + ' (' + this.getUser.profitCenter + ')' : this.getUser.userName
          })
        }
      },
      beforeAvatarUpload(file) {
        // const isJPG = FileType.includes(file.type)
        const isJPG = checkIsValidExtension(file.name);
        const isLt1G = file.size / 1024 / 1024 / 1024 < 1
        if (!isJPG) {
          this.$message.error(this.$t('PAGE_MATTERLOG_UPLOAD_TYPE'))
        }
        if (!isLt1G) {
          this.$message.error(this.$t('PAGE_MATTERLOG_UPLOAD_SIZE'))
        }
        return isJPG && isLt1G
      },
    },
    mounted() {
      this.headers = {
        Authorization: sessionStorage.getItem('JSESSIONID'),
        siteClassification: sessionStorage.getItem('siteClassification')
      }
    },
    props: {
      onAdd: Function,
      pid: {
        type: String,
        default: ''
      },
      loading: {
        type: Boolean,
        default: false
      }
    }
  };
</script>
<style scoped>
  .uploader {
    margin-bottom: 15px;
  }

  .wl-container {
    background: #fff;
    padding: 12px;
  }

  .wl-btn-container {
    margin-top: 12px;
    text-align: right;
  }

  .textarea {
    border-color: #c0c4cc;
    border-radius: 2px;
  }
</style>
